/** The backend has a single engine; spot is the same engine with no leverage. */
export const ENGINE_PROVIDER = "margin";
